//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TransientObject.js";
let d=[[[0,"BatchQuantity",1,0],[0,"BottomEdgeToPartDistance",1,0],[0,"EdgeToPartDistance",1,0],[0,"EdgeToPartDistanceOption",1,0],[0,"LeftEdgeToPartDistance",1,0],[0,"NestDirection",1,0],[0,"NestTime",1,0],[0,"OutputFilePath",1,0],[0,"OutputOption",1,0],[0,"PartToPartDistance",1,0],[0,"RemnantFolderLocation",1,0],[0,"RemnantMinArea",1,0],[0,"RemnantMinDimension",1,0],[0,"RightEdgeToPartDistance",1,0],[0,"StandardStockFilePath",1,0],[0,"TopEdgeToPartDistance",1,0]],[[[],"Dispose",{},0,0],[["layer"],"AddLayerToCutLayers",{},1,0],[["nCutLayers"],"GetCutLayers",{R_:{cutLayers:""}},0,0],[[],"ClearCutLayers",{},0,0],[["layer"],"AddLayerToAttachLayers",{},1,0],[["nAttachLayers"],"GetAttachLayers",{R_:{attachLayers:""}},0,0],[[],"ClearAttachLayers",{},0,0]],[]];
SPLM.NestingSettings = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.NestingSettings";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.NestingSettings.NestDirections = Object.freeze({
    "BottomLeft" : "BottomLeft", "BottomRight" : "BottomRight", "TopLeft" : "TopLeft", "TopRight" : "TopRight"});

SPLM.NestingSettings.EdgeToPartDistanceOptions = Object.freeze({
    "Single" : "Single", "Multiple" : "Multiple"});

SPLM.NestingSettings.OutputOptions = Object.freeze({
    "TwoD" : "TwoD", "ThreeD" : "ThreeD"});

export default SPLM;